/**
 * <TutorStudentProfileSkeleton> — la fiche d'un élève pendant son premier chargement.
 *
 * L'en-tête (le visage, le nom, la ligne grise, ses cours), la rangée d'onglets, puis les cartes de
 * l'Aperçu dans leur disposition étroite, celle d'avant toute mesure.
 */
import React from "react"
import { StyleSheet } from "react-native-unistyles"

import { Row } from "../../atoms/containers/Row"
import { Stack } from "../../atoms/containers/Stack"
import { Skeleton } from "../../atoms/Skeleton"
import { SubjectBadgeSkeleton } from "../../atoms/SubjectBadge"
import { Card } from "../../molecules/Card"
import { HighlightFrame } from "../../molecules/HighlightFrame"
import { SettingsSection } from "../../molecules/SettingsSection"
import { TUTOR_PROFILE_AVATAR_SIZE } from "../../organisms/TutorStudentHeader"

export function TutorStudentProfileSkeleton() {
    return (
        <Stack gap="4">
            <Row gap="4" align="start">
                <Skeleton shape="circle" size={TUTOR_PROFILE_AVATAR_SIZE} />
                <Stack gap="2" style={styles.body}>
                    <Skeleton textSize="text-2xl" width={150} />
                    <Skeleton textSize="text-sm" width={230} />
                    <Row gap="2" align="center">
                        <SubjectBadgeSkeleton />
                        <Skeleton textSize="text-sm" width={150} />
                    </Row>
                </Stack>
            </Row>
            <Row gap="5">
                {[52, 62, 64, 66].map((width) => (
                    <Skeleton key={width} textSize="text-md" width={width} />
                ))}
            </Row>
            <HighlightFrame>
                <Card p="4">
                    <Stack gap="2">
                        <Skeleton textSize="text-lg" />
                        <Skeleton textSize="text-lg" width="70%" />
                    </Stack>
                </Card>
            </HighlightFrame>
            <SettingsSection title="En bref">
                <Stack gap="1">
                    <Skeleton textSize="text-md" />
                    <Skeleton textSize="text-md" width="60%" />
                </Stack>
            </SettingsSection>
        </Stack>
    )
}

const styles = StyleSheet.create(() => ({
    body: { flex: 1, minWidth: 0 },
}))
